<template>
  <div v-if="localChat===null" class="text-center mt-10">
    <alert>Чат не выбран</alert>
  </div>
  <div v-else>
    <dialog-page-chat-toolbar
        :cats="cats"
        :chat="localChat"
        @close="$emit('close')"
    />
    <v-divider/>
    <v-progress-linear v-if="messagesLoading" class="position-absolute" indeterminate background-color="transparent"/>
    <v-sheet
        ref="messages"
        :min-height="heightCalc"
        :max-height="heightCalc"
        class="overflow-y-auto pt-2"
    >
      <div v-for="(v,k) in messages" :key="k">
        <dialog-message
            :message="v"
        />
      </div>
    </v-sheet>
  </div>
</template>

<script>
import Alert from "../../../componentsV2/base/Alert.vue";
import DialogPageChatToolbar from "./DialogPageChatToolbar.vue";
import axios from "axios";
import DialogMessage from "./DialogMessage.vue";

export default {
  components: {DialogMessage, DialogPageChatToolbar, Alert},
  props: ['height','cats','chat'],
  data: () => ({
    localChat:null,
    subscribeListenerId:null,
    messages:[],
    messagesLoading:false,
    heightCalc:0,
  }),
  mounted() {
    this.localChat = this.chat;
    this.heightResize();
    this.$ws.connectWithSubscribeListener(this.$store.state.user, (v)=>this.subscribeListenerId=v, (m)=>{
      if(m.type==='dialogChat' && this.localChat?.id===m.data.id) this.localChat = m.data;
    });
  },
  beforeDestroy() {
    this.$ws.removeSubscribeListener(this.subscribeListenerId);
  },
  watch:{
    chat(){this.localChat = this.chat},
    localChat(){this.loadMessages()},
  },
  methods:{
    heightResize(){
      this.$tools.debounce(()=>{
        this.$nextTick(()=>{
          this.heightCalc = this.height-48-48-1;
          if(this.localChat!==null){
            if(this.localChat.cat==='queue' || this.localChat.cat==='closed')
              this.heightCalc -= 48;
            //else
              //this.heightCalc -= this.$refs.messText.$el.getBoundingClientRect().height+1
          }
        })
      }, 100, 'chatHeightResize');
    },
    loadMessages(){
      if(this.localChat===null){
        this.messages = [];
        return;
      }

      this.messages = [];
      this.messagesLoading = true;
      axios.get('/napi/dialog/message/?dialogChatId='+this.localChat.id)
          .then(r=>{
            this.messages = r.data.reverse();
            this.messagesLoading = false;
          });
    }
  }
}
</script>